/**
 * Sold Out Fix for Collection Pages
 * Updates "Add to Bag" button to show "Sold Out" when the selected variant is unavailable.
 * Works for all product card types (single option quick-add AND multi-option overlay trigger).
 */
(function() {
  function updateCardAvailability(card) {
    var refEl = card.querySelector('[data-product-reference]');
    if (!refEl) return;
    var selectedId = refEl.dataset.selected;
    if (!selectedId) return;

    var variantEl = card.querySelector('[data-variant-reference][data-id="' + selectedId + '"]');
    var isAvailable = variantEl ? variantEl.dataset.available === 'true' : true;

    // Desktop CTA buttons
    var desktopCta = card.querySelector('.product-card__cta--desktop');
    if (desktopCta) {
      updateCtaButton(desktopCta, isAvailable);
    }

    // Mobile CTA buttons
    var mobileCta = card.querySelector('.product-card__cta--mobile');
    if (mobileCta) {
      updateCtaButton(mobileCta, isAvailable);
    }
  }

  function updateCtaButton(ctaContainer, isAvailable) {
    // Handle quick-add buttons (data-add-to-cart)
    var atcBtn = ctaContainer.querySelector('[data-add-to-cart]');
    var waitlistLink = ctaContainer.querySelector('[data-cta-link]');

    // Handle overlay trigger buttons (data-modal-trigger)
    var overlayBtn = ctaContainer.querySelector('[data-modal-trigger]');

    if (atcBtn && waitlistLink) {
      // Single option cards: toggle between ATC button and waitlist link
      if (isAvailable) {
        atcBtn.classList.remove('hidden');
        waitlistLink.classList.add('hidden');
      } else {
        atcBtn.classList.add('hidden');
        waitlistLink.classList.remove('hidden');
      }
    }

    if (overlayBtn) {
      // Multi-option cards: update button text and disable if sold out
      if (isAvailable) {
        overlayBtn.textContent = 'Add to Bag';
        overlayBtn.disabled = false;
        overlayBtn.style.opacity = '';
        overlayBtn.style.pointerEvents = '';
      } else {
        overlayBtn.textContent = 'Sold Out';
        overlayBtn.disabled = true;
        overlayBtn.style.opacity = '0.5';
        overlayBtn.style.pointerEvents = 'none';
      }
    }
  }

  // Watch for variant changes on all product cards
  function initSoldOutFix() {
    var cards = document.querySelectorAll('product-card');
    cards.forEach(function(card) {
      var refEl = card.querySelector('[data-product-reference]');
      if (!refEl) return;

      // Check initial state
      updateCardAvailability(card);

      // Watch for variant selection changes
      var observer = new MutationObserver(function() {
        updateCardAvailability(card);
      });
      observer.observe(refEl, { attributes: true, attributeFilter: ['data-selected'] });
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSoldOutFix);
  } else {
    // Small delay to let product-card web components initialize first
    setTimeout(initSoldOutFix, 500);
  }
})();
